/* @flow */

import fetchUrl from 'utils/fetch';
import type { CropConfig } from 'shared/components/ImageCrop';

export const update = (resource: BucketResource) =>
  fetchUrl(`/bucket/resources.json/${resource.id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(resource),
  });

export const crop = (resourceId: string, config: CropConfig) =>
  fetchUrl(`/bucket/resources.json/${resourceId}/crop`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config),
  }).then(res => res.blob());

export const expand = (resourceId: string, config) =>
  fetchUrl(`/bucket/resources.json/${resourceId}/expand`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config),
  }).then(res => res.blob());

export const remove = (resourceId: string) =>
  fetchUrl(`/bucket/resources.json/${resourceId}`, {
    method: 'DELETE',
  });



// WEBPACK FOOTER //
// ./src/modules/bucket/api/resources.js